// The product name, for copy that interpolates it.
//
// A single source for the name, so copy interpolates `{productName}` (CLAUDE.md i18n rule) rather than the literal.
export type ProductName = 'Symphony';

export const PRODUCT_NAME: ProductName = 'Symphony';

export function useProductName(): ProductName {
  return PRODUCT_NAME;
}
